module.exports = __webpack_public_path__ + "assets/img/car15.cd57c46f.jpg";